import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import app from './modules/app'
import user from './modules/user'
import history from './modules/history'
import config from './modules/config'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    history,
    config
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js